<template>
<span>
    <a-tooltip placement="top" :title="$t('translateText.catalog.nrbkk')" v-if='show_lock'>
        <a-icon type="lock"  @click.stop='onLock(courseNodeId,parentNodeid)'/>
    </a-tooltip>
    <a-tooltip placement="top" :title="$t('translateText.catalog.nrkk')" v-else>
        <a-icon type="unlock" @click.stop='onLock(courseNodeId)' />
    </a-tooltip>
</span>
</template>

<script>
export default{
    props: {
        courseNodeId: {
            type: Number,
            default: 0,
        },
        parentNodeid: {
            type: Number,
            default: 0,
        },
        nodeState: {
            type: Number,
            default: 0,
        },
    },
    name:"ShowLock",
    data(){
        return{
            show_lock:false
        }
    },
    methods:{
        onLock(courseNodeId,parentNodeid){
            // this.show_lock = !this.show_lock;
            this.$emit("update",this.show_lock,courseNodeId,parentNodeid)
        },
    },
    created(){
        if(this.nodeState == 2){
            this.show_lock = true
        }
    },
    watch:{
       nodeState:function(){
           this.show_lock = !this.show_lock
       }
    }
}
</script>

<style scoped>

</style>